export default "__VITE_PUBLIC_ASSET__2126c9fc__"